import { render, staticRenderFns } from "./doraemon.vue?vue&type=template&id=21ab130a"
import script from "./doraemon.vue?vue&type=script&lang=js"
export * from "./doraemon.vue?vue&type=script&lang=js"
import style0 from "./doraemon.vue?vue&type=style&index=0&id=21ab130a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports